import axios from 'config/axiosConfig'
import setFilters from 'config/filters';
import { go } from "keys/apis"
import { isArray } from 'lodash';

export const openTicketFetch = (values) => {
    let formData = new FormData();
    for (const key in values) {
        if (isArray(values[key]))//for contentImages
            values[key].forEach((image) => {
                formData.append(key, image); // 'images' הוא השם של השדה במודל
            });

        else formData.append(key, values[key]);
    }
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${go}tickets/`,
        formData
    )
}

export const sendMessageFetch = (values) => {
    let formData = new FormData();
    for (const key in values) {
        if (key == 'image') {//for contentImages
            if (values[key])
                formData.append(key, values[key].file);
        }
        else formData.append(key, values[key]);
    }
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${go}ticket_messages/`,
        formData
    )
}

export const updateMessageFetch = ({ id, values }) => {
    let formData = new FormData();
    for (const key in values) {
        if (key == 'image') {//for contentImages
            if (values[key])
                formData.append(key, values[key].file);
        }
        else formData.append(key, values[key]);
    }
    return axios.put(`${process.env.REACT_APP_SERVER_PORT}${go}ticket_messages/${id}/`,
        formData
    )
}

export const getTicketsFetch = ({ model, page, pageSize, sorting, search, ticket_type }) => {
    let params = setFilters({ model, page, pageSize, sorting, search })
    if (ticket_type != "ALL")
        params.ticket_type = ticket_type

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}tickets/`, {
        params: params
    })
}

export const getTicketFetch = ({ id }) => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}tickets/${id}/`)
}

export const getNewTicketCountFetch = () => {
    const params = {
        status: "OPEN,IN_PROGRESS"
    }
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}tickets/get_new_ticket_count/`, {
        params: params
    })
}

export const deleteTicketFetch = (id) => {
    return axios.delete(`${process.env.REACT_APP_SERVER_PORT}${go}tickets/${id}/`)
}

export const deleteTicketMessageFetch = (id) => {
    return axios.delete(`${process.env.REACT_APP_SERVER_PORT}${go}ticket_messages/${id}/`)
}


export const getTicketMessagesFetch = ({ id }) => {
    const params = {
        ticket: id
    }
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}ticket_messages/`, {
        params: params
    })
}

export const getTicketTypeCountsFetch = () => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${go}tickets/get_ticket_type_counts/`)
}


export const updateTicketFetch = ({ id, status }) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${go}tickets/${id}/update_status/`, {
        status
    })
}

export const updateTicketPriorityFetch = ({ id, priority }) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${go}tickets/${id}/update_priority/`, {
        priority
    })
}

